module.exports = __webpack_public_path__ + "static/media/left.1e0ba604.svg";